import { createFileRoute, useSearch } from '@tanstack/react-router';
import { Iframe } from 'common/components/iframe/iframe';
import { withClassicLogic } from 'features/externalPage/iframe-wrapper/withClassicLogic';

const ClassicPage = () => {
  const { url } = useSearch({ from: '/spaces/external/classic' });
  const EnhancedIframe = withClassicLogic(Iframe);

  return <EnhancedIframe url={url} />;
};

export const Route = createFileRoute('/spaces/external/classic')({
  validateSearch: ({ url }) => ({
    url: typeof url === 'string' ? encodeURI(url) : '',
  }),
  component: ClassicPage,
});
